import ParserRestApi from 'helpers/ParserRestApi';

export default function (state, action, entity) {
	if (action.type.indexOf(entity + '-') === -1) {
		return state;
	}
	let key = false;

	if (action.type.indexOf('-UPDATE_COLLECTION') !== -1) {
		let {item, type, id} = action.payload;
		if ((item || id) && type) {
			let idItem = false;
			if (item && item['@id']) {
				idItem = item['@id'];
			}
			let collection = {...state.collection};
			if (collection.items.length > 0) {
				let newItem = [];
				if (type === 'update') {
					newItem = collection.items.map((currentItem) => {
						if (currentItem['@id'] && currentItem['@id'] === idItem) {
							return item;
						}
						return currentItem;
					});
				} else if (type === 'save') {
					newItem = [...collection.items];
					newItem.unshift(item);
				} else if (type === 'delete') {
					newItem = collection.items.filter((currentItem) => {
						if (currentItem['@id'] && ParserRestApi.parseId(currentItem['@id']) !== id) {
							return true;
						}
						return false;
					});
				}
				return {
					...state,
					collection: {
						...state.collection,
						items: newItem
					}
				}
			} else {
				return {
					...state,
					collection: {
						...state.collection,
						items: [
							item
						]
					}
				}
			}
		}
		return state;
	}

	if (action.type.indexOf('_ONCE') !== -1) {
		key = 'item';
	}

	if (action.type.indexOf('_ALL') !== -1) {
		key = 'collection';
	}
	if (action.type.indexOf('_DELETE') !== -1) {
		key = 'delete';
	}

	if (key !== false) {

		let completeObjectDelete = {};
		if (key === 'delete' && action.payload) {
			let {id} = action.payload;
			if (typeof id !== 'undefined') {
				completeObjectDelete = {
					id
				};
			}
		}

		if (action.type.indexOf('GET_') !== -1) {
			let completeObject = {};
			if (key === 'collection') {
				let {total, items, itemsPerPage, page} = action.payload;
				completeObject = {
					total,
					items,
					itemsPerPage,
					page
				}
				if (typeof page !== 'undefined' && page > 1) {
					//completeObject.items = state[key].items.concat(items);
					completeObject.items = items;
				}
			}
			if (key === 'item') {
				let {props} = action.payload;
				completeObject = {
					props
				}
			}
			return {
				...state,
				[key]: {
					...completeObject,
					...completeObjectDelete,
					loaded: true,
					fetching: false,
					error: {
						status: false,
						message: '',
					}
				}
			};
		}

		if (action.type.indexOf('LOADED_') !== -1) {
			return {
				...state,
				[key]: {
					...state[key],
					...completeObjectDelete,
					loaded: true,
					fetching: false,
					error: {
						status: false,
						message: '',
					}
				}
			};
		}

		if (action.type.indexOf('FETCHING_') !== -1) {
			return {
				...state,
				[key]: {
					...state[key],
					...completeObjectDelete,
					fetching: true,
					loaded: false,
					error: {
						status: false,
						message: '',
					}
				}
			};
		}

		if (action.type.indexOf('ERROR_') !== -1) {
			const {message} = action.payload;
			return {
				...state,
				[key]: {
					...state[key],
					...completeObjectDelete,
					fetching: false,
					loaded: true,
					error: {
						status: true,
						message: message,
					}
				}
			};
		}
	}

	return state;
}
